import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import pathfinder from '@fiverr-private/pathfinder';
import { selectRecipientInfo, useStaticContext } from '../../context/contexts/static';

const ViewMessageButton = ({ children, onClick = noop, fill = Button.FILLS.GHOST, color = Button.COLORS.LIGHT_GREY }) => {
    const context = useStaticContext();
    const { username } = selectRecipientInfo(context);
    const conversationUrl = pathfinder('inbox_show', { username });

    let child = <I18n k="send_message.sent_confirmation.view_message"/>;

    if (React.isValidElement(children)){
        child = children;
    }

    return (
        <Button color={color}
            fill={fill}
            href={conversationUrl}
            onClick={onClick}
            target="_blank"
            rel="noreferrer">
            { child }
        </Button>
    );
};

ViewMessageButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    fill: PropTypes.string,
    color: PropTypes.string
};

export default ViewMessageButton;
